import React, { useState , useEffect} from "react";
import Loading from "../assetLibComponents/Loading";
import { useDispatch, useSelector } from "react-redux";
import { ArrowLeft } from "react-bootstrap-icons/dist";
import Toast from "../assetLibComponents/shared/Toast";
import {addGreetingMessage, addSuggestion, updateSuggestion, greetingMessage, addDisclamer} from "../../redux/actions/chatAiActions"
import Tab from "../Tab";
import ChatbotViewer from "./ChatbotViewer";
import { Mixpanel } from "../../Mixpanel";
import { HiOutlineInformationCircle } from "react-icons/hi";
import TnCSS from "../../assets/TnC.png"


const ChatSettings = (props) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.chatAi.loading);
  const [tabName, setTabName] = useState("General");
  const [greetingMsg, setGreetingMsg] = useState("");
  const [promptOne, setPromptOne] = useState("");
  const [promptTwo, setPromptTwo] = useState("");
  const [open, setOpen] = useState(false);
  const [promptThree, setPromptThree] = useState("");
  const [TnC, setTnC] = useState("");
  const [privacyPolicy, setPrivacyPolicy] = useState("");
  const [info, setInfo] = useState("");
  const greeting_data = useSelector((state) => state.chatAi.greeting_message);
  const tabs = [
    { name: "General", href: "#", current: true },
    { name: "Initial Prompts", href: "#", current: false },
    { name: "Disclaimer", href: "#", current: false },
  ];
  
  const handleSubmit = () => {
    if (tabName === "General") {
      if (greetingMsg !== "") {
        dispatch(addGreetingMessage(props.authToken, greetingMsg))
        if(greeting_data.message !== greetingMsg){
          Mixpanel.track("Edited the greeting message.");
        }
      } else {
          Toast("Greeting message should not be empty", "E");
      }
    } else if(tabName === "Initial Prompts") {
      if (greeting_data.details.length === 0) {
        if (promptOne !== "" && promptTwo !== "" && promptThree !== "") {
          dispatch(addSuggestion(props.authToken, promptOne, promptTwo, promptThree));
        } else {
          Toast("Prompt Should not be empty", "E");
        }
      } else {
        if (promptOne !== "" && promptTwo !== "" && promptThree !== "") {
          if(greeting_data.details[0].message !== promptOne || greeting_data.details[1].message !== promptTwo || greeting_data.details[2].message !== promptThree){
            Mixpanel.track("Edited the initial prompts.");
          }
          let data = [...greeting_data.details] 
          data.map((obj, o_index) => {
            if (o_index === 0) {
              obj.message = promptOne
            } else if (o_index === 1) {
              obj.message = promptTwo
            } else {
              obj.message = promptThree
            }
            return obj;
          })
          dispatch(updateSuggestion(props.authToken, data));
        } else {
          Toast("Prompt Should not be empty", "E");
        }
      }
    } else {
      const payload = {
        term_link: TnC,
        privacy_policy_link: privacyPolicy,
        info: info
      }
        dispatch(addDisclamer(props.authToken, payload))
          Mixpanel.track("Edited the Disclaimer");     
    }
  }
  
  useEffect(() => {
    if (Object.keys(greeting_data) && Object.keys(greeting_data)?.length) {
      setGreetingMsg(greeting_data.message);
      setTnC(greeting_data?.disclaimer?.term_link)
      setPrivacyPolicy(greeting_data?.disclaimer?.privacy_policy_link)
      setInfo(greeting_data?.disclaimer?.info)
      if (greeting_data?.details?.length > 0) {
        setPromptOne(greeting_data.details[0].message);
        setPromptTwo(greeting_data.details[1].message);
        setPromptThree(greeting_data.details[2].message);
      } else {
        setPromptOne("");
        setPromptTwo("");
        setPromptThree("");
      }
    } else {
      setGreetingMsg("");
      setPromptOne("");
      setPromptTwo("");
      setPromptThree("");
    }
  }, [greeting_data])

  console.log(greeting_data,"greeting_data")
  
  useEffect(() => {
    dispatch(greetingMessage(props.authToken));
  }, [])
  
  const chatOpenHandle = (value) => {
    setOpen(value);
  }
  
  
  return (
    <>
      {isLoading && <Loading />}
      {/* Heading with button */}
      <div className="flex justify-between mb-2 border-b border-gray-200 pb-4">
        <div className="text-lg leading-7 font-[500] my-auto">Settings</div>
        <div className="flex">
          <button
            // onClick={()=>{setOpen(true)}}
            type="button"
            className="mr-4 inline-flex border border-gray-300 items-center gap-x-1.5 rounded-md bg-transparent px-3 py-2 text-sm font-semibold text-gray-700 shadow-sm"
            onClick={()=>{handleSubmit();}}
          >
            Save Changes
          </button>
          <button
            onClick={()=>{setOpen(true)}}
            type="button"
            className="inline-flex items-center gap-x-1.5 rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] "
          >
            <ArrowLeft className="-ml-0.5 h-5 w-5" aria-hidden="true" />
            Test ChatAI
          </button>
        </div>
      </div>
      {/* Tabs */}
      <Tab tabs={tabs} setTabName={setTabName} tabName={tabName} />
      {/* Tabs Content */}
      {tabName === "Initial Prompts" && (
        <div className="bg-white rounded-md px-4 py-6 mt-6">
          <div className="rounded-md mb-2 px-3 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
            <label
              htmlFor="name"
              className="block text-xs font-medium text-gray-800"
            >
              Prompt 1
            </label>
            <input
              type="text"
              name="name"
              id="name"
              className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
              placeholder="Enter Text Here"
              value={promptOne}
              onChange={(e)=>{setPromptOne(e.target.value)}}
            />
          </div>
          <div className="rounded-md mb-2 px-3 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
            <label
              htmlFor="name"
              className="block text-xs font-medium text-gray-800"
            >
              Prompt 2
            </label>
            <input
              type="text"
              name="name"
              id="name"
              className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6 focus:ring focus:ring-white focus:ring-offset-0"
              placeholder="Enter Text Here"
              value={promptTwo}
              onChange={(e)=>{setPromptTwo(e.target.value)}}
            />
          </div>
          <div className="rounded-md  px-3 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
            <label
              htmlFor="name"
              className="block text-xs font-medium text-gray-800"
            >
              Prompt 3
            </label>
            <input
              type="text"
              name="name"
              id="name"
              className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6 focus:ring focus:ring-white focus:ring-offset-0"
              placeholder="Enter Text Here"
              value={promptThree}
              onChange={(e)=>{setPromptThree(e.target.value)}}
            />
          </div>
        </div>
      )}
      {tabName === "General" && (
        <div className="bg-white rounded-md px-4 py-6 mt-6">
          <div className="rounded-md px-3 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
            <label
              htmlFor="name"
              className="block text-xs font-medium text-gray-800"
            >
              Enter Greeting Message
            </label>
            <input
              type="text"
              name="name"
              id="name"
              className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
              placeholder="Greeting"
              value={greetingMsg}
              onChange={(e)=>setGreetingMsg(e.target.value)}
            />
          </div>
        </div>
      )}
      {tabName === "Disclaimer" && (
        <div className="bg-white rounded-md px-6 mt-6 pb-2">
          <div className="flex">
          <img
                  className="mx-auto my-3 h-20"
                  src={TnCSS}
                  alt="Your Company"
                />
          </div>
          <div className="rounded-md mb-2 px-3 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
            <label
              htmlFor="name"
              className="block text-xs font-medium text-gray-800"
            >
              TnC
            </label>
            <input
              type="text"
              name="name"
              id="name"
              className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
              placeholder="Add a hyperlink for TnC"
              value={TnC}
              onChange={(e)=>{setTnC(e.target.value)}}
            />
          </div>
          <div className="rounded-md mb-2 px-3 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
            <label
              htmlFor="name"
              className="block text-xs font-medium text-gray-800"
            >
              Privacy Policy
            </label>
            <input
              type="text"
              name="name"
              id="name"
              className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6 focus:ring focus:ring-white focus:ring-offset-0"
              placeholder="Add a hyperlink for Privacy Policy"
              value={privacyPolicy}
              onChange={(e)=>{setPrivacyPolicy(e.target.value)}}
            />
          </div>
          <div className="rounded-md mb-2 px-3 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300">
            <label
              htmlFor="name"
              className="block text-xs font-medium text-gray-800"
            >
              <HiOutlineInformationCircle className="text-gray-900 text-[1rem] my-auto"></HiOutlineInformationCircle>
            </label>
            <input
              type="text"
              name="name"
              id="name"
              className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6 focus:ring focus:ring-white focus:ring-offset-0"
              placeholder="Add a text"
              value={info}
              onChange={(e)=>{setInfo(e.target.value)}}
            />
          </div>
        </div>
      )}
      
      <ChatbotViewer authToken={props.authToken} open={open} chatOpenHandle={chatOpenHandle} autoQuestion="" />
    </>
  );
};

export default ChatSettings;
